import {useEffect, useState} from "react"
import EntityForm from "./EntityForm";
import {UsePatch, UsePut} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";

const Edit = ({audience, id_entity}) => {
    const [errors, setErrors] = useState()
    const [fields, setFields] = useState()
    const [entity, setEntity] = useState()
    const [isLoading, setIsLoading] = useState(true)

    const GetData = async () => {

        const requestEntity = await UsePut(
            `/audiences/${audience?._id?.$oid}/entities/get`,
            {data: {limit: 1, offset: 0, _id: id_entity}}
        )

        const requestFields = await UsePut(
            `/audiences/${audience?._id?.$oid}/fields/get/audience`,
            {data: {offset: 0}, toArray: true, propValue: 'name', propLabel: 'name'}
        )


        return {
            fields: requestFields,
            entity: requestEntity?.entities[0],
        }

    }


    useEffect(() => {
        GetData().then((response) => {
            setFields(response.fields)
            setEntity(response.entity)
            setIsLoading(false)
        })
    }, [])


    const handleUpdate = (PostData) => {
        setIsLoading(true)

        UsePatch(
            `/audiences/${audience?._id?.$oid}/entities/${id_entity}/update`,
            {data: PostData}
        ).then((response) => {

            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    UseMessage('success', 'Entity has been successfully updated')
                    setErrors(undefined)
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }


    return (
        <>
            <EntityForm fields={fields} entity={entity} errors={errors} isReady={!isLoading} onSubmit={handleUpdate}/>
        </>
    )
}

export default Edit